import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    button:
      'text-md text-bg-items-black hover:text-brand-400 border-0 font-semibold hover:cursor-pointer hover:bg-transparent',
    label: 'ml-2',
    icon: 'hover:stroke-brand-400 w-[24px]! rotate-90'
  },
  variants: {
    visibility: {
      base: {},
      mobile: {
        button: 'lg:hidden'
      }
    }
  },
  defaultVariants: {
    visibility: 'base'
  }
});
